import Logo from "../../public/AfricFreshLogo-01.svg";
import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { FaShoppingCart } from 'react-icons/fa';

const Navbar = () => {
  const [isUser, setIsUser] = useState(null); // Initialize state as null

  // Fetch user details from localStorage on component mount
  useEffect(() => {
    const user = localStorage.getItem("AficFreshuserDetails");
    if (user) {
      const parsedUser = JSON.parse(user); // Parse the JSON string
      setIsUser(parsedUser);
      console.log(parsedUser)
    }
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <nav className="bg-white fixed w-full z-50 text-[#007D44] flex justify-between items-center p-4 max-sm:bg-white">
      {/* Left Section */}
      <div className="flexspace-x-4">
        {/* Logo */}
        <Link to="/">
        <img src={Logo} alt="Logo" className="h-14 flex max-sm:ml-[30%] " />
        </Link>
      </div>

      {/* Right Section */}
      <div className="flex items-center space-x-6 max-sm:hidden">
        {/* Language Selector */}

        {/* User Dropdown */}
        <span className="cursor-pointer">
        Hi, {isUser ? `${isUser.firstName}` : "Guest User"}
        </span>

        
      </div>
    </nav>
  );
};

export default Navbar;
